import { formatDateToUTCWithFormat } from "../../../../../utils/formatDate";
import { GiConfiguration } from "../hooks/useGiConfiguration";

/**
 * Generates display items for a GI configuration card.
 *
 * Transforms a GiConfiguration object into an array of label-value pairs
 * suitable for rendering in a ViewCard component.
 *
 * @param {GiConfiguration} item - The GI configuration to extract display data from
 * @returns {Array<{label: string, value: string}>} Array of label-value pairs containing:
 *   - "Updated On": Formatted last updated date (DD MMM YYYY)
 *   - "No. of Orders": Number of orders as string
 *
 * @example
 * const items = generateGiConfigurationItemsData(giConfig);
 * // Returns: [
 * //   { label: "Updated On", value: "15 Jan 2026" },
 * //   { label: "No. of Orders", value: "10" }
 * // ]
 */
export const generateGiConfigurationItemsData = (item: GiConfiguration) => {
  return [
    {
      label: "Updated On",
      value: formatDateToUTCWithFormat(item?.last_updated ?? "", "DD MMM YYYY"),
    },
    { label: "No. of Orders", value: item.num_orders?.toString() || "" },
  ];
};
